import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft, BarChart3, ClipboardList, Link2 } from "lucide-react";
import { AdminGate } from "@/components/admin/AdminGate";
import { BlackfeoAdminShell, BLACKFEO_MODULOS } from "@/components/admin/BlackfeoAdminShell";

const T = "Admin · BLACKFEO 2026";
const D = "Seção da BLACKFEO 2026: plano, dashboard e páginas da ação.";
export const Route = createFileRoute("/admin/black-november")({
  head: () => ({ meta: [{ title: T }, { name: "description", content: D }, { property: "og:title", content: T }, { property: "og:description", content: D }, { property: "og:type", content: "website" }, { name: "twitter:card", content: "summary" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: () => <AdminGate route="/admin/black-november"><Hub /></AdminGate>,
});

function Hub() {
  const mods = [
    { to: "/admin/plano-black-november" as const, icon: ClipboardList, t: "Plano da ação", d: "Preços, order bumps, metas e checklist" },
    { to: "/admin/black-november-dashboard" as const, icon: BarChart3, t: "Dashboard", d: "Meta x realizado em tempo real" },
    { to: "/admin/black-november-paginas" as const, icon: Link2, t: "Páginas da ação", d: "Catálogos, LPs e checkouts" },
  ];
  return (
    <BlackfeoAdminShell title="BLACKFEO 2026" description="Todos os nossos produtos com até 80% de desconto · Meta R$800.000 · Cupom BLACKFEO">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {BLACKFEO_MODULOS.map(({ to, icon: I, title: t, desc: d }) => (
            <Link key={to} to={to} className="rounded-lg border border-border bg-card p-6 transition hover:border-primary">
              <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg border border-primary/30 bg-primary/15"><I className="h-6 w-6 text-black-campaign-lilac" /></div><h2 className="font-bold">{t}</h2><p className="mt-1.5 text-sm text-muted-foreground">{d}</p>
            </Link>
          ))}
        </div>
    </BlackfeoAdminShell>
  );
}
